export function requiresResolution(previousStatus: string | null | undefined, nextStatus: string): boolean {
  return nextStatus === 'resolved' && previousStatus !== 'resolved';
}

export function resolutionError(previousStatus: string | null | undefined, input: {
  status: string;
  category: string;
  resolving_technician_name?: string | null;
  capa_root_cause?: string | null;
  capa_corrective_action?: string | null;
  capa_preventive_action?: string | null;
}): string {
  if (!requiresResolution(previousStatus, input.status)) return '';
  if (!input.resolving_technician_name?.trim()) return 'Resolving technician name is required to mark this case resolved.';
  if (input.category === 'issue' && (!input.capa_root_cause?.trim() || !input.capa_corrective_action?.trim() || !input.capa_preventive_action?.trim())) {
    return 'Root cause, corrective action, and preventive action are all required to resolve an issue.';
  }
  return '';
}

export function resolutionHint(teamName?: string | null): string {
  const team = teamName?.trim() ? `the ${teamName.trim()} support team` : 'this support team';
  return `Field technician: report completion to the configured head/coordinator for ${team}, using existing team routing. The coordinator marks the case resolved with the technician name; customer care calls the customer next.`;
}
